import { useContext } from 'react';
import { TranslatesContext } from './context';

export const useTranslates = () => useContext(TranslatesContext);
